import { handleNetworkError, showSuccessToast } from '../../utils';
import { fetchConfigs, saveConfig, fetchSupportedBanks, saveSupportedBank, createSupportedBank, deleteSupportedBank } from '../../services/API';
import router from '../../router';

export const getConfigs = async ({ commit }) => {
    commit('FETCHING_CONFIGS', true);

    try {
        const response = await fetchConfigs();
        const configs = response.filter(({ displayName }) => displayName && displayName.length > 0);
        commit('FETCHING_CONFIGS', false);
        commit('SET_CONFIGS', configs);
    } catch (error) {
        commit('FETCHING_CONFIGS', false);
        handleNetworkError(error, "Error fetching general configs:");
    }
}

export const setConfigBeingEdited = ({ state, commit }, configName) => {
    if (!configName)
        commit('SET_CONFIG_BEING_EDITED', null);

    if (!state.configs)
        return;

    const config = state.configs.find(({ name }) => name === configName);
    commit('SET_CONFIG_BEING_EDITED', config);
}

export const updateConfig = async ({ commit, state }, updatedConfig) => {
    commit('SAVING_CONFIG', true);
    try {
        const { name, value } = updatedConfig;
        const data = {
            config: [{ name, value }]
        };

        await saveConfig(data);
        commit('SAVING_CONFIG', false);

        let configs = state.configs;
        if (!configs)
            configs = [];

        configs = configs.map(config => {
            if (config._id === updatedConfig._id)
                return updatedConfig;

            return config;
        });

        commit('SET_CONFIGS', configs);
        router.replace('/configurations/general');
        showSuccessToast(updatedConfig.displayName + " updated");
    } catch (error) {
        handleNetworkError(error, `Error saving ${updatedConfig.displayName}:`);
        commit('SAVING_CONFIG', false);
    }
}

export const getSupportedBanks = async ({ commit }, page) => {
    commit('FETCHING_SUPPORTED_BANKS', true);

    try {
        const {data, pagination} = await fetchSupportedBanks(page);
        commit('FETCHING_SUPPORTED_BANKS', false);
        commit('SET_SUPPORTED_BANKS', {data, pagination});
    } catch (error) {
        commit('FETCHING_SUPPORTED_BANKS', false);
        handleNetworkError(error, "Error fetching supported banks:");
    }
}

export const setSupportedBankBeingEdited = ({ state, commit }, bankId) => {
    if (!bankId)
        commit('SET_SUPPORTED_BANK_BEING_EDITED', null);

    if (!state.supportedBanks)
        return;

    const supportedBank = state.supportedBanks.find(({ _id }) => _id === bankId);
    commit('SET_SUPPORTED_BANK_BEING_EDITED', supportedBank);
}

export const addSupportedBank = async ({ commit, state }, data) => {
    commit('SAVING_SUPPORTED_BANK', true);
    try {
        const supportedBank = await createSupportedBank(data);
        commit('SAVING_SUPPORTED_BANK', false);

        let supportedBanks = state.supportedBanks;
        if (!supportedBanks)
            supportedBanks = [];

        supportedBanks.push(supportedBank);

        commit('SET_SUPPORTED_BANKS', {data: supportedBanks});
        router.replace('/configurations/supportedBanks');
        showSuccessToast(supportedBank.code + " added to supported banks");
    } catch (error) {
        handleNetworkError(error, `Error creating supported bank:`);
        commit('SAVING_SUPPORTED_BANK', false);
    }
}

export const updateSupportedBank = async ({ commit, state }, updatedBankDetails) => {
    commit('SAVING_SUPPORTED_BANK', true);
    try {
        await saveSupportedBank(updatedBankDetails);
        commit('SAVING_SUPPORTED_BANK', false);

        let supportedBanks = state.supportedBanks;
        if (!supportedBanks)
            supportedBanks = [];

        supportedBanks = supportedBanks.map(supportedBank => {
            if (supportedBank._id === updatedBankDetails._id)
                return updatedBankDetails;

            return supportedBank;
        });

        commit('SET_SUPPORTED_BANKS', {data: supportedBanks});
        router.replace('/configurations/supportedBanks');
        showSuccessToast(updatedBankDetails.code + " updated");
    } catch (error) {
        handleNetworkError(error, `Error saving ${updatedBankDetails.code}:`);
        commit('SAVING_SUPPORTED_BANK', false);
    }
}

export const removeSupportedBank = async ({ commit, state }, {bankId, bankName}) => {
    let supportedBanks = state.supportedBanks;
    if(!supportedBanks)
        supportedBanks = [];

    function setDeletingBankStatus(deleting){
        supportedBanks = supportedBanks.map(supportedBank => {
            if(supportedBank._id === bankId)
                return {...supportedBank, deleting};

            return supportedBank;
        });
        commit('SET_SUPPORTED_BANKS', {data: supportedBanks});
    }

    try {
        setDeletingBankStatus(true);
        await deleteSupportedBank(bankId);
        
        supportedBanks = supportedBanks.filter(supportedBank => {
            return supportedBank._id !== bankId;
        });
        commit('SET_SUPPORTED_BANKS', {data: supportedBanks});

        showSuccessToast(`${bankName} removed from supported banks`);
    } catch (error) {
        handleNetworkError(error, `Error removing ${bankName} from supported banks:`);
        setDeletingBankStatus(false);
    }
}